// Kullanıcı Taşıma (User Migration, Firebase → SQL, süper admin) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'superadmin.userMigration';

export const superAdminUserMigrationGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Kullanıcı Taşıma nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Firebase\'deki sistem kullanıcılarını (admin, manager, employee, courier, superadmin) merkezi SQL kullanıcı tablosuna aktarırsınız. Aktarım geri alınamaz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'User Migration'),
    stats: t(`${G}.regions.stats`, 'İstatistik kartları'),
    filters: t(`${G}.regions.filters`, 'Rol Dağılımı'),
    toolbar: t(`${G}.regions.toolbar`, 'İşlemler'),
    table: t(`${G}.regions.table`, 'Firebase Kullanıcıları'),
    pagination: t(`${G}.regions.pagination`, 'Import Sonucu'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Durumu görün'),
      text: t(`${G}.s1.text`, 'Kartlar SQL\'deki Toplam Kullanıcı, Şifre Tamamlanan, Şifre Bekleyen ve Tamamlanma Oranı değerlerini gösterir. Rol Dağılımı her roldeki kullanıcı sayısını verir. "İstatistikleri Yenile" ile güncelleyin.'),
      tips: [
        t(`${G}.s1.tip1`, 'Şifre Bekleyen: aktarılmış ama henüz giriş yapıp şifresi oluşmamış kullanıcılar.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s2.title`, '2. Kullanıcıları yükleyin'),
      text: t(`${G}.s2.text`, 'En kolay yol JSON dosyasıdır: Firebase Console → Realtime Database → "users" düğümüne sağ tıklayın → "Export JSON" → dosyayı "JSON Dosyası Yükle" ile seçin. Firebase kuralları izin veriyorsa "Firebase\'den Çek" düğmesi listeyi doğrudan okur.'),
      tips: [
        t(`${G}.s2.tip1`, 'Yalnız admin, manager, employee, courier ve superadmin rolündeki kullanıcılar alınır; diğerleri yok sayılır.'),
        t(`${G}.s2.tip2`, '"Firebase erişim izni yok" hatası alırsanız JSON dosyası yükleyin.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Listeyi kontrol edin'),
      text: t(`${G}.s3.text`, 'Firebase Kullanıcıları tablosunda e-posta, ad soyad, rol, şirket ve Firebase UID görünür. Aktarmadan önce rollerin ve şirketlerin doğru olduğunu kontrol edin.'),
      tips: [
        t(`${G}.s3.tip1`, 'E-postası veya rolü olmayan kayıtlar aktarılmaz.'),
      ],
    },
    {
      region: 'toolbar',
      title: t(`${G}.s4.title`, '4. Aktarın: bu işlem geri alınamaz'),
      text: t(`${G}.s4.text`, '"SQL\'e Toplu Import" → onay penceresinde "Import Et". Yeni kullanıcılar şifresiz eklenir; kullanıcı ilk girişinde şifresi otomatik oluşur. Geri alma düğmesi yoktur; eklenen kayıtlar SQL\'de kalır.'),
      tips: [
        t(`${G}.s4.tip1`, '"Mevcut kayıtları güncelle (şifre hariç)" kapalıysa SQL\'de aynı Firebase UID\'li kullanıcı atlanır.'),
        t(`${G}.s4.tip2`, 'Açıksa o kullanıcının e-posta, ad soyad, rol, şirket, şube ve personel bilgileri JSON\'daki değerlerle üzerine yazılır; şifre korunur. SQL\'de sonradan değiştirilmiş rol veya şirket bilgisi eski değere döner. Emin değilseniz kapalı bırakın.'),
        t(`${G}.s4.tip3`, 'E-postası SQL\'de başka bir UID ile zaten kayıtlı olan kullanıcı atlanır; listede aynı e-posta birden çok kez varsa yalnız biri alınır.'),
        t(`${G}.s4.tip4`, 'Toplu import yalnız süper admin tarafından yapılabilir.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s5.title`, '5. Sonucu okuyun'),
      text: t(`${G}.s5.text`, 'Import Sonucu kutusunda Toplam, Oluşturulan, Güncellenen, Atlanan ve varsa Hatalar sayısı görünür; istatistik kartları da kendiliğinden yenilenir.'),
    },
  ],
});
